import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    h: "Acceptance of terms",
    body: [
      "By accessing or using the Imaginepedia Technologies website and any services we make available (collectively, the \"Services\"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Services.",
    ],
  },
  {
    h: "Use of the site",
    body: [
      "You may access this site for lawful, personal and business informational purposes. You agree not to interfere with the operation of the site, attempt unauthorized access, or use automated systems to scrape content at a rate that impairs the service for others.",
    ],
  },
  {
    h: "Intellectual property",
    body: [
      "All content on this site — including copy, code samples, illustrations, brand marks and the 3D assets — is the property of Imaginepedia Technologies or its licensors and is protected by applicable law. You may not reproduce, distribute or create derivative works without written permission.",
    ],
  },
  {
    h: "Engagements and contracts",
    body: [
      "Any commercial engagement between you and Imaginepedia Technologies is governed by a separate signed Statement of Work or Master Services Agreement. Nothing on this website constitutes an offer or a binding contract on its own.",
    ],
  },
  {
    h: "Third-party links",
    body: [
      "The site may reference or link to third-party resources. We are not responsible for the content, availability, or practices of those third parties.",
    ],
  },
  {
    h: "Disclaimer of warranties",
    body: [
      "The site is provided on an \"as is\" and \"as available\" basis without warranties of any kind, express or implied. We do not warrant that the site will be uninterrupted, error-free, or free of harmful components.",
    ],
  },
  {
    h: "Limitation of liability",
    body: [
      "To the maximum extent permitted by law, Imaginepedia Technologies shall not be liable for indirect, incidental, special, consequential or punitive damages arising out of your use of the site.",
    ],
  },
  {
    h: "Changes to these terms",
    body: [
      "We may update these terms from time to time. Continued use of the site after changes are posted constitutes acceptance of the updated terms.",
    ],
  },
  {
    h: "Governing law",
    body: [
      "These terms are governed by the laws of India, without regard to conflict-of-law principles. Courts located in Bengaluru, Karnataka shall have exclusive jurisdiction.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testId="page-terms"
      index={1}
      label="Legal"
      title="Terms of Service."
      updated="10 December 2025"
      sections={SECTIONS}
    />
  );
}
